module.exports = __webpack_public_path__ + "img/academic-services-mobile-hero.9038aced.webp";